import React from "react";
import Tile from "../../components/Tile/Tile";
import { ContentfulTileProps } from "../../utils/contentful-helpers";
import { useWithSessionData } from "../../hooks/use-with-session-data";
import { useAppDispatch, useAppSelector } from "../../app/store";
import { bookmarkEventBuilder, sendEvent } from "../../utils/event-helpers";
import { toggleResourceBookmark } from "../../features/bookmark/resourceBookmarksSlice";

export interface ResourceTileProps {
  resourceTiles: ContentfulTileProps[];
}

const TalkToAnExportResourceTiles = ({ resourceTiles }: ResourceTileProps) => {

  const { userId, sessionId } = useWithSessionData();
  const dispatch = useAppDispatch();
  const bookmarks = useAppSelector((state) => state.resourceBookmarks.bookmarkedResources);
  const handleBookmarkTalkToAnExpert = (resourceTile: ContentfulTileProps) => {
    const { id, title, description, thumbnail, url } = resourceTile;
    const isBookmarked = bookmarks.some((bookmark) => bookmark.id === id);
    const eventData = bookmarkEventBuilder(!isBookmarked, userId, sessionId, "TalkToAnExpertTile", title, {
      bookmarkedResource: {
        title: title,
        description: JSON.stringify(description),
        resource_id: id,
      },
    });
    sendEvent(eventData);

    dispatch(
      toggleResourceBookmark({ id, title, description, thumbnail, url })
    );
  };

  return (
    <div className="resource-tiles-grid">
      {resourceTiles.map((tile) => (
        <div key={tile.id}>
          <Tile
            id={tile.id}
            title={tile.title}
            description={tile.description}
            thumbnail={tile.thumbnail}
            url={tile.url}
            isResearchPage={false}
            onBookmark={() => {
              handleBookmarkTalkToAnExpert(tile);
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default TalkToAnExportResourceTiles;
